import { render, staticRenderFns } from "./Konfirmasi.vue?vue&type=template&id=7af54566&scoped=true"
import script from "./Konfirmasi.vue?vue&type=script&lang=js"
export * from "./Konfirmasi.vue?vue&type=script&lang=js"
import style0 from "./Konfirmasi.vue?vue&type=style&index=0&id=7af54566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af54566",
  null
  
)

export default component.exports